// src/stores/app/inboxAlertStore.ts
//
// Avisos de desconexão de inbox exibidos na lateral direita.
// Recebe eventos CONEXAO/DESCONEXAO (via chatStore) e mantém a lista de
// inboxes desconectados que o operador ainda não dispensou.

import { defineStore } from 'pinia';
import { IdInbox } from '@/services/common-types';

export interface InboxAlert {
    id  : IdInbox;
    nome: string;
}

interface InboxAlertState {
    // Inboxes desconectados atualmente visíveis na lateral.
    alerts: InboxAlert[];
    // Inboxes que o usuário dispensou no X — não voltam a aparecer até reconectar.
    dismissed: IdInbox[];
}

export const useInboxAlertStore = defineStore('inbox-alert', {
    state: (): InboxAlertState => ({
        alerts: [],
        dismissed: [],
    }),

    actions: {
        // Inbox caiu: mostra o aviso, a menos que o usuário já o tenha dispensado.
        notifyDisconnected(id: IdInbox, nome: string) {
            if (this.dismissed.includes(id)) return;
            if (this.alerts.some(a => a.id === id)) return;
            this.alerts.push({ id, nome });
        },

        // Inbox voltou: remove o aviso e zera o "dispensado" para alertar de novo
        // numa futura queda.
        notifyConnected(id: IdInbox) {
            this.alerts = this.alerts.filter(a => a.id !== id);
            this.dismissed = this.dismissed.filter(d => d !== id);
        },

        // Usuário clicou no X: esconde e não exibe de novo enquanto seguir desconectado.
        dismiss(id: IdInbox) {
            this.alerts = this.alerts.filter(a => a.id !== id);
            if (!this.dismissed.includes(id)) this.dismissed.push(id);
        },
    },

    // Persistir só o "dispensado": ao recarregar, avisos voltam a ser semeados
    // pelo chatStore conforme o status real, mas o que o usuário dispensou continua oculto.
    persist: {
        pick: ['dismissed'],
    },
});
